<template>
  <section>
    <SelectColumns
        v-if="showSelectColumnsPopup"
        :columns="allColumns"
        ref="columnSelectionRef"
        @close-popup="showSelectColumnsPopup = false"
        @change="onColumnSelectionChange"></SelectColumns>
    <a
        @click="doPrint()"
        class="tab_button tab_button_print"
        :title="'Tisknout' | translate"
        v-translate>Tisknout
    </a>
    <export-excel
        class="tab_button tab_button_csv"
        :data='filteredRows'
        :fields='fieldsForExport'
        :name='exportFileName+".csv"'
        type="csv"
        style="cursor: pointer"
        :escapeCsv="false"
    ></export-excel>
    <export-excel
        class="tab_button tab_button_xls"
        :data='filteredRows'
        :fields='fieldsForExport'
        :name='exportFileName+".xls"'
        style="cursor: pointer"
    ></export-excel>
    <div class="program_table">
      <table class="vypis lower_row">
        <thead class="no_sortable">
        <tr class="scrollable_header">
          <th v-if="!printMode" class="no_padding drag_drop"></th>
          <th v-if="!printMode" class="no_padding checkbox drag_drop">
            <a @click="showColumnSelection"
               class="column_settings"
               :title="$gettext('Nastavení sloupců')" v-translate>Nastavení sloupců</a>
          </th>
          <th class="channel_name" v-translate>Název kanálu</th>
          <th class="center" v-for="channelPackage in selectedColumns">
            {{ channelPackage.name }}
          </th>
        </tr>
        </thead>
        <tbody>
        <program-structure-row
            v-if="showData"
            v-for="(row, index) in filteredRows"
            :row="row"
            :printMode="printMode"
            :key="index"
        ></program-structure-row>
        <tr>
          <td class="center" :colspan="selectedColumns.length +3" v-if="filteredRows.length == 0" v-translate>Žádné kanály k zobrazení</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="program_legend_box">
      <program-structure-list
          :list="packageListToShow"></program-structure-list>
    </div>
  </section>
</template>

<script>
import ProgramStructureRow from "@/components/views/downloads/program-structure/ProgramStructureRow";
import ProgramStructureList from "@/components/views/downloads/program-structure/ProgramStructureList";
import SelectColumns from "@/components/common/tabs/SelectColumns";
import userSettings from "@/components/mixins/user-settings";

export default {
  name: "ProgramStructure",
  components: {
    ProgramStructureRow,
    ProgramStructureList,
    SelectColumns
  },
  mixins: [userSettings],
  props: {
    channels: Array,
    basicChannelPackages: Object,
    idOperator: String | Number,
  },
  data: function () {
    return {
      moduleName: 'programStructure',
      showSelectColumnsPopup: false,
      selectedColumns: [],
      printMode: false,
      selection: [],
    };
  },
  computed: {
    allColumns(){
      let result = {};
      for(let [key, value] of Object.entries(this.basicChannelPackages)){
        result[key] = {name: value.name, disabled: value.channel_ids.length === 0}
      }
      return result;
    },
    showData(){
      return this.filteredRows.length > 0;
    },
    selectedPackageIds() {
      return this.selectedColumns.map(item => item.id);
    },
    fieldsForExport() {
      let obj = {"": "name"};
      for (const item of this.selectedColumns) {
        obj[item.name] = {
          field: item.name,
          callback: (value) => {
            return value ? "X" : "";
          }
        };
      }
      return obj;
    },
    exportFileName() {
      return "export_channel_structure_4net_backoffice_" + (new Date()).toISOString().substring(0, 10);
    },
    channelsToShow() {
      return this.channels.filter((item) => {
        return this._.intersection(item.in_packages, this.selectedPackageIds);
      });
    },
    packageListToShow() {
      if (this.printMode) {
        return this.basicChannelPackages.filter((item) => {
          return this.selectedPackageIds.includes(item.id) === true;
        });
      } else {
        return this.basicChannelPackages;
      }
    },
    filteredRows() {
      let result = [];
      for (const channel of this.channelsToShow) {
        let line = {};
        let inAnyPackage = false;
        line = {
          id: channel.id,
          name: channel.name
        };
        for(let column of this.selectedColumns) {
          if (channel.in_packages.includes(parseInt(column.id))) {
            line[column.name] = true;
            inAnyPackage = true;
          } else {
            line[column.name] = false;
          }
        }
        if (inAnyPackage) {
          result.push(line);
        }
      }

      return result;
    }
  },
  methods: {
    initColumns(){
      let savedColumns = this.getSettingByKey('selectedColumns');
      if(savedColumns instanceof Object && savedColumns.hasOwnProperty(this.idOperator)){
        this.onColumnSelectionChange(savedColumns[this.idOperator]);
      }else{
        let defaultColumnMaxCount = this.basicChannelPackages.length < 5 ? this.basicChannelPackages.lenght : 5;
        let defaultColumns = [];
        let count = 0;
        for(let key in this.basicChannelPackages){
          if(count >= defaultColumnMaxCount){
            break;
          }
          defaultColumns.push(key);
          count++;
        }
        this.onColumnSelectionChange(defaultColumns);
      }
    },
    showColumnSelection(){
      this.showSelectColumnsPopup = true;
      this.$nextTick(() => this.$refs.columnSelectionRef.initSelection(this.selection));
    },
    onColumnSelectionChange(columns) {
      this.selectedColumns = [];
      this.selection = columns;
      for(let itemId of columns){
        this.selectedColumns.push(this.basicChannelPackages[itemId]);
      }
      let savedColumns = this.getSettingByKey('selectedColumns');
      if(!(typeof savedColumns instanceof Object)){
        savedColumns = {};
      }
      savedColumns[this.idOperator] = this.selection;
      this.setUserSetting('selectedColumns', savedColumns);
    },
    doPrint() {
      // temporary change for generating print layout
      this.printMode = true;
      this.$nextTick(() => print());
      this.$nextTick(() => this.printMode = false);
    }
  },
  watch:{
    basicChannelPackages(){
      this.initColumns()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/downloads/program-structure/ProgramStructure.vue